module.exports = __webpack_public_path__ + "img/headervisual-1200-2x.7f8c3679.jpg";